import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetBranchesReqData } from "./GetBranchesReqData";
import { GetBranchesResData } from "./GetBranchesResData";

const ENDPOINT = "/branch";

export class DeleteBranchCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";

    params: DeleteBranchReqData = null;

    constructor(branchId: number) {
        super();
        this.params = new DeleteBranchReqData(branchId);
    }

    public async execute(): Promise<GetBranchesResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetBranchesResData(res);
    }
}

export class DeleteBranchReqData {
    id: number;
    constructor(branchId: number) {
        this.id = branchId;
    }
}
